import React from 'react';
import {Link, LinkProps, useLocation} from 'react-router-dom';
import {useI18n} from '../../i18n/useI18n';
import {buildLocalizedSitePath, getSiteLocaleFromPathname} from '../../i18n/siteLocalePath';

const SiteLink: React.FC<LinkProps> = ({to, ...props}) => {
    const location = useLocation();
    const {locale} = useI18n();
    const activeLocale = getSiteLocaleFromPathname(location.pathname) ?? locale;

    const resolvedTo = typeof to === 'string'
        ? buildLocalizedSitePath(to, activeLocale)
        : {
            ...to,
            pathname: buildLocalizedSitePath(to.pathname ?? location.pathname, activeLocale)
        };

    return <Link {...props} to={resolvedTo}/>;
};

export default SiteLink;
